import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
export function AnnouncementBar() {
  return <div className="bg-ink text-canvas" data-id="element-9" data-mp="okaaav88uzhe">
      <a href="#briefs" className="group mx-auto flex max-w-6xl items-center justify-center gap-2 px-6 py-2 font-mono text-xs" data-id="element-10" data-mp="olbtjmzeysa7">
        <span className="rounded bg-accent px-1.5 py-0.5 font-medium text-accent-ink" data-id="element-11" data-mp="jrqya2p7gcep">new</span>
        <span className="opacity-80" data-id="element-12" data-mp="et63iisq2kxn">v2 API is live in 150+ countries</span>
        <span className="font-medium" data-id="element-13" data-mp="9x8oqgx3xmmz">read the docs</span>
        <ArrowRightIcon className="h-3.5 w-3.5 transition-transform duration-150 ease-out group-hover:translate-x-1" aria-hidden="true" data-id="element-14" data-mp="5u2l7h1dq9k7" />
      </a>
    </div>;
}